import { render, staticRenderFns } from "./undoInMarket.vue?vue&type=template&id=48b6c872&scoped=true"
import script from "./undoInMarket.vue?vue&type=script&lang=js"
export * from "./undoInMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6c872",
  null
  
)

export default component.exports